'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Switch, Route, Redirect, useParams } from 'react-router-dom';
import ErrorPage from '../components/pages/ErrorPage';
import HomePage from '../components/pages/HomePage';
import ResultsPage from '../components/pages/ResultsPage';
import InputUtil from '../util/InputUtil';
import { TESTS, ERROR, ROOT } from '../constants/Paths';

var getSanitizedHostname = function getSanitizedHostname(websiteUrl) {
  return InputUtil.parseWebsiteUrl(decodeURIComponent(websiteUrl));
};

var ProtectedResultsPage = function ProtectedResultsPage() {
  var _useParams = useParams(),
      websiteUrl = _useParams.websiteUrl;

  var hostname = getSanitizedHostname(websiteUrl);
  return hostname === websiteUrl ? /*#__PURE__*/_jsx(ResultsPage, {}) : /*#__PURE__*/_jsx(Redirect, {
    to: TESTS + "/" + hostname
  });
};

export default (function () {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: TESTS + "/:websiteUrl",
      component: ProtectedResultsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: ERROR + "/:errorType?",
      component: ErrorPage
    }), /*#__PURE__*/_jsx(Route, {
      path: ROOT,
      exact: true,
      component: HomePage
    }), /*#__PURE__*/_jsx(Redirect, {
      to: ROOT
    })]
  });
});